export class LinkedItemsHelper {
    convertLinkedItemsToArray(linkedItems) {
        const linkedItemsArray = [];
        for (const linkedItemKey of Object.keys(linkedItems)) {
            linkedItemsArray.push(linkedItems[linkedItemKey]);
        }
        return linkedItemsArray;
    }
}
export const linkedItemsHelper = new LinkedItemsHelper();
//# sourceMappingURL=linked-items.helper.js.map